import React, {Component} from 'react';
import moment from 'moment';

import {
    Card, CardBody, CardHeader,
    Col,
    ListGroupItem,
    Row
} from 'reactstrap';

import PolyUtil from '../../util/PolyUtil';
import {educationLevels} from "../../util/FormConstants";
import StatusIcon from "../display/StatusIcon";

class ApplicationCardWrapper extends Component {
    render() {

        const {children, complete, title} = this.props;

        return (
            <Card color={!complete ? 'warning' : 'default'} className="pr-card" outline>
                <CardHeader tag="h4">{title}</CardHeader>
                <CardBody>
                    {
                        complete ? children : (<h4>Incomplete</h4>)
                    }
                </CardBody>
            </Card>
        );

    }
}

export class BasicCard extends Component {
    render() {
        const {application} = this.props;
        const age = moment().diff(moment(application.birth_date), 'year');
        const education = educationLevels.find(function (item) {
            return item.value === application.highest_education_level;
        });
        return (
            <ApplicationCardWrapper title="Basic Info" complete={application.is_basic_complete}>
                <Row>
                    <Col><strong>Age:</strong></Col>
                    <Col>{age}</Col>
                </Row>
                <Row>
                    <Col><strong>Date of Birth:</strong></Col>
                    <Col>{moment(application.birth_date).format('MM/DD/YYYY')}</Col>
                </Row>
                <Row>
                    <Col><strong>Education: </strong></Col>
                    <Col>{education && education.name}</Col>
                </Row>
                <hr/>
                <Row>
                    <Col xs={12}><h4>Contact:</h4></Col>
                    <Col><strong>Email:</strong><br/>{application.email}</Col>
                    <Col><strong>Phone:</strong><br/>{PolyUtil.formatPhone(application.phone)}</Col>
                </Row>
            </ApplicationCardWrapper>
        );
    }
}

export class RentalHistoryCard extends Component {
    render() {

        const {rental_history} = this.props;

        return (
            <ApplicationCardWrapper title="Rental History" complete={PolyUtil.validArr(rental_history)}>
                {
                    rental_history.map(function (rental, i) {
                        let start = moment(rental.lease_start);
                        let end = moment(rental.lease_end);

                        let range = end.isAfter(moment()) ? 'Current Residence' : start.format('MM/DD/YYYY') + " - " + end.format('MM/DD/YYYY');
                        let reference = rental.reference && rental.reference.name + ": " + PolyUtil.formatPhone(rental.reference.phone) + ", " + rental.reference.email;

                        return (
                            <div key={i}>
                                <Row>
                                    <Col xs={5}>
                                        <strong>{PolyUtil.getPropertyAddressString(rental)}</strong>
                                    </Col>
                                    <Col xs={3}>
                                        <small>{range}</small>
                                    </Col>
                                    <Col xs={4}>
                                        {reference}
                                    </Col>
                                </Row>
                                {
                                    (i !== rental_history.length - 1) && (<hr/>)
                                }
                            </div>
                        );
                    })
                }
            </ApplicationCardWrapper>
        );
    }
}

export class EmploymentHistoryCard extends Component {
    render() {

        const {employment_history} = this.props;

        return (
            <ApplicationCardWrapper title="Employment History" complete={PolyUtil.validArr(employment_history)}>
                {
                    employment_history.map(function (employment, i) {
                        return (
                            <div key={i}>
                                <Row>
                                    <Col xs={3}>
                                        <strong>{employment.title}</strong>{' - ' + employment.employer_name}
                                    </Col>
                                    <Col xs={3}>
                                        <small>{employment.employer_city + ', ' + employment.employer_state}</small>
                                    </Col>
                                    <Col xs={3}>
                                        <small>{PolyUtil.formatUSD(employment.gross_income) + "/year"}</small>
                                    </Col>
                                    <Col xs={3}>
                                        <small>Employed from {PolyUtil.formatDate(employment.start_date)} to {employment.end_date ? PolyUtil.formatDate(employment.end_date) : 'Now'}</small>
                                    </Col>
                                </Row>
                                {
                                    (i !== employment_history.length - 1) && (<hr/>)
                                }
                            </div>
                        );
                    })
                }
            </ApplicationCardWrapper>
        );
    }
}

export class GeneralCard extends Component {
    render() {

        const {application} = this.props;
        return (
            <ApplicationCardWrapper title="General" complete={application.is_advanced_complete}>
                <ListGroupItem>
                    <Col xs={12} sm={10}><strong>Do you smoke?</strong></Col>
                    <Col xs={12} sm={2}>{application.is_smoker ? 'Yes' : 'No'} <StatusIcon value={!application.is_smoker}/></Col>
                </ListGroupItem>
                <ListGroupItem>
                    <Col xs={12} sm={10}><strong>Do you have pets/service animals?</strong></Col>
                    <Col xs={12} sm={2}>{application.has_pets ? 'Yes' : 'No'} <StatusIcon value={!application.has_pets}/></Col>
                </ListGroupItem>
                <ListGroupItem>
                    <Col xs={12} sm={10}><strong>Do you have liquid furniture?</strong></Col>
                    <Col xs={12} sm={2}>{application.liquid_furniture ? 'Yes' : 'No'} <StatusIcon value={!application.liquid_furniture}/></Col>
                </ListGroupItem>
                <ListGroupItem>
                    <Col xs={12} sm={10}><strong>Have you ever been evicted?</strong></Col>
                    <Col xs={12} sm={2}>{application.eviction ? 'Yes' : 'No'} <StatusIcon value={!application.eviction}/></Col>
                </ListGroupItem>
                <ListGroupItem>
                    <Col xs={12} sm={10}><strong>Have you been convicted of a felony?</strong></Col>
                    <Col xs={12} sm={2}>{application.conviction ? 'Yes' : 'No'} <StatusIcon value={!application.conviction}/></Col>
                </ListGroupItem>
                <ListGroupItem>
                    <Col xs={12} sm={10}><strong>Have you filed for bankruptcy in the past 7 years?</strong></Col>
                    <Col xs={12} sm={2}>{application.bankruptcy_filed ? 'Yes' : 'No'} <StatusIcon value={!application.bankruptcy_filed}/></Col>
                </ListGroupItem>
            </ApplicationCardWrapper>
        );
    }
}

export class BioCard extends Component {
    render() {

        const {application} = this.props;
        return (
            <ApplicationCardWrapper title="Bio" complete={application.is_bio_complete}>
                <Row>
                    <Col><p>{application.bio}</p></Col>
                </Row>
            </ApplicationCardWrapper>
        );
    }
}

export class VehicleCard extends Component {
    render() {
        const {application} = this.props;
        return (
            <ApplicationCardWrapper title="Vehicle Info" complete={application.is_vehicle_complete}>
                <Row>
                    <Col><strong>DL #:</strong></Col>
                    <Col>{application.drivers_license_number}</Col>
                </Row>
                <Row>
                    <Col><strong>License Expiration:</strong></Col>
                    <Col>{moment(application.drivers_license_expiration).format('MM/DD/YYYY')}</Col>
                </Row>
                <Row>
                    <Col><strong>State: </strong></Col>
                    <Col>{application.drivers_license_state}</Col>
                </Row>
                <hr/>
                <Row>

                </Row>

                {
                    (application.skip_vehicle || !application.vehicle) ? (
                        <Row>
                            <Col>
                                Doesn't have a vehicle
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col xs={7}>
                                <strong>Vehicle:</strong><br/>{application.vehicle.color + " " + application.vehicle.year + " " + application.vehicle.make + " " + application.vehicle.model}
                            </Col>
                            <Col xs={5}><strong>License Plate:</strong><br/>{application.vehicle.license_plate_number}</Col>
                        </Row>
                    )
                }

            </ApplicationCardWrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/application/ApplicationCards.js